import { Flex, Switch, Typography } from "antd";
import { useTranslate } from "@refinedev/core";
import { useTemplateEditorStore } from "../../../store/useTemplateEditorStore";
import { useTemplatesStatusStore } from "../../../store/useTemplatesStatusStore";

export const SpeakTransitionTitleToggle = () => {
  const t = useTranslate();

  const { templateState, updateTemplateState } = useTemplateEditorStore(
    (store) => ({
      templateState: store.templateState,
      updateTemplateState: store.updateTemplateState,
    })
  );

  const { addTemplateUpdate } = useTemplatesStatusStore((store) => ({
    addTemplateUpdate: store.addTemplateUpdate,
  }));

  // A visible avatar always needs its (fixed) title script to speak — silencing
  // it would leave a visible presenter saying nothing. Enabling the avatar
  // already forces speechType to FixedScript (see AvatarTab), so once it's on,
  // this toggle has nothing valid left to switch to and should not appear.
  const hasVisibleAvatar = !!templateState.presenter.presenter?.face_profile;
  if (hasVisibleAvatar) return null;

  const checked = templateState.transition.speechType === "FixedScript";

  const handleChange = (value: boolean) => {
    updateTemplateState({
      transition: {
        ...templateState.transition,
        speechType: value ? "FixedScript" : "Silence",
      },
    });
    addTemplateUpdate();
  };

  return (
    <Flex vertical gap={4}>
      <Flex align="center" justify="space-between">
        <Typography.Text>
          {t("components.templates.settings.scriptTab.transition.speakTitle")}
        </Typography.Text>
        <Switch checked={checked} size="small" onChange={handleChange} />
      </Flex>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {t(
          "components.templates.settings.scriptTab.transition.speakTitleSubtext"
        )}
      </Typography.Text>
    </Flex>
  );
};
